import { Divider } from "@mui/material";
import { genderLabels, getLevelLabel } from "../../enums/recruitment";
import { formatDate, getRangeSalary } from "./ultil";

const InfoItem = ({ icon, label, value, gap = 8 }) => (
  <div
    className="flex items-center flex-row mt-2 min-w-[160px]"
    style={{ columnGap: gap }}
  >
    <img src={icon} className="w-[30px] h-[30px]" />
    <div>
      <p>{label}</p>
      <p>
        <b>{value}</b>
      </p>
    </div>
  </div>
);

const DeadlineInfo = ({ deadline }) => (
  <div className="flex gap-2 mt-4 bg-[#E1F7FF] px-3 py-2 rounded-lg">
    <img src="/assets/icons/ic_clock_bold.svg" className="w-6 h-6" />
    <p className="text-[#1C9BDB]">Hạn nộp hồ sơ: {formatDate(deadline)}</p>
  </div>
);

const GeneralInfo = ({ workingForm, gender, quantity }) => (
  <div className=" px-3">
    <p className="text-[18px] text-[#033F6A] font-semibold">Thông tin chung</p>
    <InfoItem
      icon="/assets/icons/ic_laptop.svg"
      label="Hình thức làm việc"
      value={workingForm === 1 ? "Toàn thời gian" : "Part time"}
      gap={16}
    />
    <InfoItem
      icon="/assets/icons/ic_user_square.svg"
      label="Giới tính"
      value={genderLabels[gender]}
      gap={16}
    />
    <InfoItem
      icon="/assets/icons/ic_user_multiple.svg"
      label="Số lượng"
      value={quantity < 10 ? `0${quantity}` : quantity}
      gap={16}
    />
  </div>
);

const ContactInfo = () => (
  <div className=" px-3">
    <p className="text-[18px] text-[#033F6A] font-semibold">
      Liên hệ tuyển dụng
    </p>
    <InfoItem
      icon="/assets/icons/ic_call.svg"
      label="Hotline"
      value="0968.596.859"
      gap={16}
    />
    <InfoItem
      icon="/assets/icons/ic_sms_tracking.svg"
      label="Mail"
      value="hr@blueskyit.vn"
      gap={16}
    />
    <InfoItem
      icon="/assets/icons/ic_location_gps_2.svg"
      label="Địa chỉ công ty"
      value="BT16B6 -32, Làng Việt Kiều Châu Âu, Mỗ Lao, Hà Đông, Hà Nội"
      gap={16}
    />
  </div>
);

function RecruitmentDetailInfoSidebar({ recruitment, groupButton }) {
  return (
    <div className="py-5 rounded-lg" style={{ border: "1px solid #F1F0F0" }}>
      <p className="text-[#033F6A] text-2xl font-semibold px-4">
        {recruitment.title}
      </p>
      <div className="mt-4">
        <div className="px-3">
          <div className="flex gap-4">
            <InfoItem
              icon="/assets/icons/ic_money_dollar.svg"
              label="Mức lương"
              value={
                recruitment.startSalary !== undefined
                  ? getRangeSalary(
                      recruitment.startSalary.toString(),
                      recruitment.endSalary.toString(),
                      recruitment.salaryLevel
                    )
                  : null
              }
            />
            <InfoItem
              icon="/assets/icons/ic_location_gps.svg"
              label="Địa điểm"
              value={<b>Hà Nội</b>}
            />
          </div>
          <div className="flex gap-4 mt-4">
            <InfoItem
              icon="/assets/icons/ic_timer.svg"
              label="Kinh nghiệm"
              value={<b>{recruitment.experience}</b>}
            />
            <InfoItem
              icon="/assets/icons/ic_location_gps.svg"
              label="Cấp bậc"
              value={<b>{getLevelLabel(recruitment.level)}</b>}
            />
          </div>
          <DeadlineInfo deadline={recruitment.deadlineTime} />
          {groupButton}
        </div>
        <Divider sx={{ my: 2 }} />
        <GeneralInfo
          workingForm={recruitment.workingForm}
          gender={recruitment.gender}
          quantity={recruitment.quantity}
        />
        <Divider sx={{ my: 2 }} />
        <ContactInfo />
      </div>
    </div>
  );
}

export default RecruitmentDetailInfoSidebar;
